<template>
  <v-container fluid class="px-0">
    <el-overlay-loading :loading="pageloading" />
      <!-- title  -->
      <h1 class="mb-1">{{ $t('Nepavykę JAR duomenų perdavimai') }}</h1>

      <!-- search -->
      <jar-failed-jobs-search :loading="loading" @search="doSearch" />
      <!-- table -->
      <v-data-table
        class="mb-4 custom-table sticky-header"
        :loading="loading || paginationloading"
        :headers="filteredHeader"
        :items="filterItemList"
        :hide-default-footer="hideFooter"
        :header-props="{
          sortByText: $t('Rūšiuoti pagal')
        }"
        :footer-props="{
          showFirstLastPage: true,
          showCurrentPage: true,
          itemsPerPageText: $t('Rodyti po:'),
          itemsPerPageAllText: $t('visi'),
          itemsPerPageOptions: itemsPerPageOptions,
        }"
        :sort-by.sync="pagination.sort"
        :sort-desc.sync="pagination.sortDesc"
        :server-items-length="pagination.total"
        :items-per-page="pagination.pageSize"
        :page.sync="pagination.page"
        @update:options="updatePagination"
      >
        <!-- custom templates -->
        <template #[`item.actions`]="{ item }">
          <div class="nowrap">
            <el-table-action
              :item="item"
              @retryItem="confirmInModaltem(item)"
              @viewInModaltem="viewInModaltem(item)"
            />
          </div>
        </template>
        <!-- basic templates -->
        <template slot="loading"> {{ $t('Kraunasi...') }} </template>
        <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
        <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
        <template #[`footer.page-text`]="props">
          {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }} {{ $t('iš') }}
          {{ props.itemsLength }}
        </template>
      </v-data-table>
      <modal-jar-error
        v-model="showModal"
        info
        :loading="loading"
        :item="selectedItem"
      />
      <modal-confirm
        :title="confirmModalTitle"
        :text="confirmModalText"
        v-model="showConfirmModal"
        @confirmData="retryItem"
        @closeConfirmModal="clearSelectedItem"
        :loading="loading"
        width="600px"
      />

  </v-container>
</template>

<script>
import JarFailedJobsSearch from './JarFailedJobsSearch'
import userRole from '@/mixins/userRole'
import { mapGetters } from 'vuex'
import math from '@/mixins/math'
import ModalJarError from '@/components/modals/ModalJarError'
import ModalConfirm from '@/components/modals/ModalConfirm'

export default {
  name: 'JarFailedJobs',
  components: {
    JarFailedJobsSearch, ModalJarError, ModalConfirm
  },
  mixins: [userRole, math],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      listData: [],
      searchData: {},
      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },

      showModal: false,
      selectedItem: null,

      showConfirmModal: false,
      confirmModalTitle: "",
      confirmModalText: "",
    }
  },
  computed: {
    ...mapGetters(['listParams']),
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('UUID'),
          align: 'center',
          value: 'uuid',
        },
        {
          text: this.$t('Klaida'),
          align: 'start',
          value: 'exception_short',
        },
        {
          text: this.$t('Klaidos data ir laikas'),
          align: 'start',
          value: 'failed_at',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },

    hideFooter() {
      return this.pagination.total <= 10
    },
  },
  created() {
    this.setlistParams()
  },
  methods: {
    clearSelectedItem() {
      this.selectedItem = null
    },
    retryItem() {
        this.loading = true
        this.pageloading = true
        this.paginationloading = true
        this.$axios.post(`jar-failed-jobs/${this.selectedItem.id}/retry`)
        .then((res) => {
          this.$root.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
          this.selectedItem = null
          this.showConfirmModal = false
        })
    },
    setlistParams(){
      if (this.listParams && (this.pagination.pageSize != this.listParams.pageSize) && (this.listParams.pageSize != null)) {
        this.pagination.pageSize = this.listParams.pageSize
      } 
    },
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`jar-failed-jobs/list`, data)
        .then((res) => {
          this.listData = res.data.jarFailedJobs
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    viewInModaltem(item){
      this.$axios
        .get(`jar-failed-jobs/${item.id}`).then((res) => {
          this.selectedItem = res.data.jarFailedJob
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        this.showModal = true
    },
    confirmInModaltem(item){
      this.selectedItem = item;
      this.showConfirmModal = true
      this.confirmModalTitle = 'UUID: ' + item.uuid
      this.confirmModalText = "Ar tikrai norite grąžinti užduotį į eilę pakartotiniam atlikimui?"
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
          pageSize: pagination.itemsPerPage,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    doSearch(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(true)
    },
  },
}
</script>
